// Generated by Melange

import * as Caml_obj from "melange.js/caml_obj.js";
import * as Caml_option from "melange.js/caml_option.js";
import * as Curry from "melange.js/curry.js";
import * as Json__Json_encode from "melange-json/Json_encode.js";
import * as Stdlib__Array from "melange/array.js";
import * as Stdlib__Int32 from "melange/int32.js";
import * as Stdlib__Int64 from "melange/int64.js";
import * as Stdlib__List from "melange/list.js";

function make(f) {
  return f;
}

function encode(f, x) {
  return Curry._1(f, x);
}

function unit(param) {
  return null;
}

const int32 = Stdlib__Int32.to_string;

const int64 = Stdlib__Int64.to_string;

function list(encode, l) {
  return Json__Json_encode.array(encode, Stdlib__Array.of_list(l));
}

function field($$default, encode, name, data) {
  return {
    TAG: /* F */ 0,
    _0: {
      TAG: /* Required */ 1,
      _0: {
        name: name,
        data: data,
        encode: encode
      },
      _1: $$default
    }
  };
}

function field_o($$default, encode, name, data) {
  return {
    TAG: /* F */ 0,
    _0: {
      TAG: /* Optional */ 0,
      _0: {
        name: name,
        data: data,
        encode: encode
      },
      _1: $$default
    }
  };
}

function obj(fields) {
  return Json__Json_encode.object_(Stdlib__List.fold_left((function (acc, f) {
    const f$1 = f._0;
    if (f$1.TAG === /* Optional */ 0) {
      const match = f$1._0;
      const data = match.data;
      if (data === undefined) {
        return acc;
      }
      const s = Caml_option.valFromOption(data);
      const $$default = f$1._1;
      const encode = match.encode;
      const name = match.name;
      if ($$default !== undefined && Caml_obj.caml_equal(s, Caml_option.valFromOption($$default))) {
        return acc;
      } else {
        return {
          hd: [
            name,
            Curry._1(encode, s)
          ],
          tl: acc
        };
      }
    }
    const $$default$1 = f$1._1;
    const match$1 = f$1._0;
    const encode$1 = match$1.encode;
    const data$1 = match$1.data;
    const name$1 = match$1.name;
    if ($$default$1 !== undefined && Caml_obj.caml_equal(Caml_option.valFromOption($$default$1), data$1)) {
      return acc;
    } else {
      return {
        hd: [
          name$1,
          Curry._1(encode$1, data$1)
        ],
        tl: acc
      };
    }
  }), /* [] */ 0, fields));
}

function tuple1(f, x) {
  return [Curry._1(f, x)];
}

function contramap(f, g, b) {
  return Curry._1(g, Curry._1(f, b));
}

function constr0(prim) {
  return prim;
}

function constr1(s, f, x) {
  return Json__Json_encode.pair((function (prim) {
    return prim;
  }), f, [
    s,
    x
  ]);
}

function option_as_constr(f, s) {
  if (s !== undefined) {
    return Json__Json_encode.pair((function (prim) {
      return prim;
    }), f, [
      "Some",
      Caml_option.valFromOption(s)
    ]);
  } else {
    return "None";
  }
}

function adapter(restore, writer, x) {
  return Curry._1(restore, Curry._1(writer, x));
}

function string(prim) {
  return prim;
}

function $$float(prim) {
  return prim;
}

function $$int(prim) {
  return prim;
}

function bool(prim) {
  return prim;
}

const $$char = Json__Json_encode.$$char;

const array = Json__Json_encode.array;

const tuple2 = Json__Json_encode.tuple2;

const tuple3 = Json__Json_encode.tuple3;

const tuple4 = Json__Json_encode.tuple4;

const nullable = Json__Json_encode.nullable;

export {
  make,
  encode,
  unit,
  string,
  $$float,
  $$int,
  bool,
  $$char,
  list,
  array,
  int32,
  int64,
  field,
  field_o,
  obj,
  tuple1,
  tuple2,
  tuple3,
  tuple4,
  constr0,
  constr1,
  contramap,
  nullable,
  option_as_constr,
  adapter,
}
/* Stdlib__Int32 Not a pure module */
